export default {"src":"/accounts/_next/static/media/NotificationsBlue.dc865043.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};